// Pure helpers for rendering a research article's citation line.
// Extracted from Research.js so the formatting logic is unit-testable.

/**
 * Format an ISO date string to "YYYY-MM". Returns '' for missing/invalid input.
 * Uses UTC getters: a date-only string like "2025-05-01" is parsed as UTC
 * midnight, so local getters would roll back a day (→ wrong month) in
 * negative-UTC timezones. UTC getters keep the month stable.
 */
export const formatArticleDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
};

/** First author + "et al." e.g. "Alehagen U, Aaseth J" → "Alehagen U et al." */
export const formatAuthorName = (authorName) => {
  if (!authorName || authorName.trim() === '') return '';
  return `${authorName.split(',')[0].trim()} et al.`;
};

/**
 * Strip the parenthetical publisher location that clutters journal names,
 * e.g. "Antioxidants (Basel, Switzerland)" → "Antioxidants".
 * Only a trailing parenthetical is removed; mid-name parens are left intact.
 */
export const formatJournal = (journal) => {
  if (!journal) return '';
  return journal.replace(/\s*\([^)]*\)\s*$/, '').trim();
};

/** Build "YYYY-MM · Journal · First Author et al.", omitting any missing parts. */
export const buildCitation = (article) => {
  if (!article) return '';
  return [
    formatArticleDate(article.date_published),
    formatJournal(article.journal_title),
    formatAuthorName(article.first_author_name),
  ].filter(Boolean).join(' · ');
};
